/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';
import { defineMessages, injectIntl } from '@nebula/izzy/intl';
import ModalDialog from '@nebula/luna/dist/core/modal-dialog';
import TaskList from '@react/react-spectrum/Icon/TaskList';
import ViewList from '@react/react-spectrum/Icon/ViewList';
import { SideNav, SideNavItem } from '@react/react-spectrum/SideNav';
import styles from './styles/index.styl';

const MSG = defineMessages({
  done: {
    id: 'gemini.settings.done',
    defaultMessage: 'Done'
  },
  pluginValidationItem: {
    id: 'gemini.settings.pluginValidationItem',
    defaultMessage: 'Manage Validations'
  },
  pluginViewItem: {
    id: 'gemini.settings.pluginviewitem',
    defaultMessage: 'Manage Views'
  },
  title: {
    id: 'gemini.settings.title',
    defaultMessage: 'Settings'
  }
});

const SettingsModal = ({
  enableValidationPlugins = false,
  izzy,
  onClose,
  onSelectView,
  open,
  selectedView = 'viewPlugins',
  validationPluginsWidget,
  viewPluginsWidget
}) => {
  const defaultNavItems = [{ icon: <ViewList />, label: MSG.pluginViewItem, value: 'viewPlugins' }];
  const featuredNavItems = [...(enableValidationPlugins
    ? [{ icon: <TaskList />, label: MSG.pluginValidationItem, value: 'validationPlugins' }] : [])];
  const navItems = defaultNavItems.concat(featuredNavItems);

  return (
    <React.Fragment>
      <ModalDialog
        className={styles.dialog}
        title={izzy(MSG.title)}
        mode="fullscreen"
        isDismissible
        onClose={onClose}
        open={open}
        confirmLabel={izzy(MSG.done)}
      >
        <div className={styles.root}>
          <div className={styles.settingsNav}>
            <SideNav
              onSelect={onSelectView}
              value={selectedView}
            >
              {navItems.map(({ icon, label, value }) => (
                <SideNavItem
                  className={styles.navItem}
                  icon={icon}
                  key={value}
                  value={value}
                >
                  {izzy(label)}
                </SideNavItem>
              ))}
            </SideNav>
          </div>

          <div className={styles.contentArea}>
            {selectedView === 'viewPlugins' ? viewPluginsWidget : selectedView === 'validationPlugins' ? validationPluginsWidget : null}
          </div>
        </div>
      </ModalDialog>
    </React.Fragment>
  );
};

SettingsModal.displayName = 'SettingsModal';
export default injectIntl(SettingsModal);
